import fieldMixin from '@maison/mixins/fieldMixin';

import CheckboxListItemField from '@maison/components/form/fields/CheckboxListItemField';

export default {
  components: {
    CheckboxListItemField,
  },

  mixins: [fieldMixin],

  props: {
    modelValue: {
      type: Array,
      default: () => [],
    },
  },

  computed: {
    ariaLabelledby() {
      return `${this.field.id}-label`;
    },
  },
};
